module.exports = __webpack_public_path__ + "img/licence2.2105d560.jpg";